import React, {useState} from 'react';
import {
    ArrayField,
    Button,
    ChipField,
    Datagrid,
    DateField,
    Pagination,
    ReferenceArrayField,
    ReferenceManyField,
    SingleFieldList,
    TextField,
    useTranslate
} from 'react-admin';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import {d4UrlSchema} from "./Env";

// Helper function to render a field if it exists in the record
export const renderIfExists = (record, field, component) => {
    return record && record[field] && component;
};

// Helper function to render ReferenceArrayField or ReferenceManyField based on array length
export const renderReferenceField = (record, source, reference, label, props) => {
    const array = record[source];
    if (!array || array.length === 0) return null;

    if (array.length <= 5) {
        return (
            <ReferenceArrayField label={label} source={source} reference={reference}>
                <SingleFieldList linkType="show">
                    <ChipField source="objName" clickable/>
                </SingleFieldList>
            </ReferenceArrayField>
        );
    }

    return (
        <ReferenceManyField
            label={label}
            source={source}
            target="id"
            reference={reference}
            perPage={10}
            pagination={<Pagination rowsPerPageOptions={[10, 50, 100, 500]} {...props} />}
            sort={{field: 'name', order: 'ASC'}}
            filter={{context: `${d4UrlSchema}/base.jsonld`}}
        >
            <SingleFieldList linkType="show">
                <ChipField source="objName" clickable/>
            </SingleFieldList>
        </ReferenceManyField>
    );
};

const CollapsibleProperties = ({record, source, rowStyle}) => {
    const translate = useTranslate();
    const [isVisible, setIsVisible] = useState(false);

    if (!record[source] || record[source].length === 0) return null;

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    return (
        <div>
            <Button
                label={isVisible ? translate('resources.ui.hideAllProperties') : translate('resources.ui.showAllProperties')}
                onClick={toggleVisibility}
                startIcon={isVisible ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}
            />
            {isVisible && (
                <ArrayField label="Properties" source={source}>
                    <Datagrid rowStyle={rowStyle} bulkActionButtons={false}>
                        <TextField source={`${source.split(':')[0]}:prop_id`}/>
                        <TextField source={`${source.split(':')[0]}:prop_val`}/>
                    </Datagrid>
                </ArrayField>
            )}
        </div>
    );
};

export const renderProperties = (record, source, rowStyle) => (
    <CollapsibleProperties record={record} source={source} rowStyle={rowStyle}/>
);

// Helper function to render date fields
export const renderDateField = (record, source, label) => {
    return renderIfExists(record, source,
        <DateField label={label} source={source} style={{color: '#A0A0A0'}} showTime/>
    );
};
